import { render } from "./MenuContentItemValueTextWithSave.vue?vue&type=template&id=bb239c62"
import script from "./MenuContentItemValueTextWithSave.vue?vue&type=script&lang=js"
export * from "./MenuContentItemValueTextWithSave.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__